<template>
  <div class="export-more-files">
    <el-form :model="ruleForm" ref="ruleForm" label-width="50px">
      <el-form-item label="模板：">
        <el-dropdown trigger="click" @command="handleCommand">
          <el-button type="primary" plain icon="el-icon-download">下载模板</el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :command="1">单选题模板</el-dropdown-item>
            <el-dropdown-item :command="2">多选题模板</el-dropdown-item>
            <el-dropdown-item :command="3">判断题模板</el-dropdown-item>
            <el-dropdown-item :command="4">填空题模板</el-dropdown-item>
            <el-dropdown-item :command="5">主观题模板</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-form-item>
      <el-form-item label="试题分类：" required>
        <el-cascader v-model="ruleForm.categoryId" :options="sortList" :props="{ expandTrigger: 'hover', emitPath: false, checkStrictly: true }"></el-cascader>
      </el-form-item>
      <el-form-item label="上传文件：" required>
        <upload-excel-component style="margin-top: 10px" :on-success="handleImportSuccess" :before-upload="beforeUpload" :button-disabled="importLoading" />
      </el-form-item>
      <el-form-item label="步骤：">
        <div style="color: #9e9e9e">第一步：点击下载模板按钮，下载对应题型的excel模板</div>
        <div style="color: #9e9e9e">第二步：选择此次批量导入的试题分类</div>
        <div style="color: #9e9e9e">第三步：使用模板整理试题，将excel文件上传到平台</div>
      </el-form-item>
    </el-form>
    <div class="box box-align-center box-pack-end mt-btns" style="margin-top: 24px; margin-right: 30px">
      <!-- <el-button type="primary" plain @click="saveData">确定</el-button> -->
      <el-button type="danger" plain @click="cancelData">取消</el-button>
    </div>
  </div>
</template>
<script>
import host from '@/api/index';
import { formatJson } from '@/utils/utils';
import { encrypt, decrypt } from '@/api/common_encrypt';
import { zgsourceAllCategory, batchSaveQuestion } from '@/api/index';
import * as XLSX from 'xlsx';
import UploadExcelComponent from '@/components/UploadExcel/index.vue';
var that = null;
export default {
  name: 'exportMoreFiles',
  //   props: {
  //     title: {
  //       type: String,
  //       default: '',
  //     },
  //     tHeader: {
  //       type: Array,
  //       default: () => [],
  //     },
  //   },
  components: {
    UploadExcelComponent,
  },
  data() {
    return {
      ruleForm: {},
      importLoading: false,
      title: '',
      tHeader: '',
      categoryId: null,
      sortList: [],
    };
  },
  computed: {
    uploadImg() {
      return host.uploadImgUrl;
    },
    headers() {
      return {
        'bg-token': localStorage.getItem('token'), // 直接从本地获取token就行
      };
    },
  },
  mounted() {
    that = this;
    that.getLiveCategory();
  },
  methods: {
    handleCommand(val) {
      if (val == 1) {
        this.title = '单选题模板';
        this.tHeader = [
          '题干（必填）',
          '选项A（必选）',
          '选项B（必选）',
          '选项C',
          '选项D',
          '选项E',
          '选项F',
          '选项G',
          '选项H',
          '正确答案（必填）',
          '解析',
          '试题标签',
          '难度(1:简单;2:普通;3:困难)',
        ];
        this.downLoadMb();
      } else if (val == 2) {
        this.title = '多选题模板';
        this.tHeader = [
          '标题（必填）',
          '选项A（必选）',
          '选项B（必选）',
          '选项C',
          '选项D',
          '选项E',
          '选项F',
          '选项G',
          '选项H',
          '正确答案（必填）',
          '解析',
          '试题标签',
          '难度(1:简单;2:普通;3:困难)',
        ];
        this.downLoadMb();
      } else if (val == 3) {
        this.title = '判断题模板';
        this.tHeader = ['题干（必填）', '正确答案（必填）', '解析', '试题标签', '难度(1:简单;2:普通;3:困难)'];
        this.downLoadMb();
      } else if (val == 4) {
        this.title = '填空题模板';
        this.tHeader = ['题干（必填）', '答案1', '答案2', '答案3', '答案4', '答案5', '答案6', '答案7', '答案8', '答案9', '答案10', '解析', '试题标签', '难度(1:简单;2:普通;3:困难)'];
        this.downLoadMb();
      } else if (val == 5) {
        this.title = '主观题模板';
        this.tHeader = ['题干（必填）', '答案（必填）', '解析', '试题标签', '难度'];
        this.downLoadMb();
      }
    },
    //获取所有直播分类(树型结构)
    getLiveCategory() {
      let info = {
        type: 2,
      };
      console.log(info);
      var data = encrypt(JSON.stringify(info));
      zgsourceAllCategory(data).then((res) => {
        if (res.result == 1) {
          var ress = JSON.parse(decrypt(res.data));
          console.log('获取所有直播分类', ress);
          that.sortList = that.listFor(ress);
        } else {
          that.$message({
            showClose: true,
            message: res.msg,
            type: 'error',
          });
        }
      });
    },
    listFor(arr) {
      let children = [];
      if (arr != null && arr != '' && arr != undefined) {
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].childCourseCategory != '' && arr[i].childCourseCategory != null && arr[i].childCourseCategory != undefined) {
            children.push({
              value: arr[i].id,
              label: arr[i].name,
              children: this.listFor(arr[i].childCourseCategory),
            });
          } else {
            children.push({
              value: arr[i].id,
              label: arr[i].name,
              children: this.listFor(arr[i].childCourseCategory),
            });
          }
        }
      } else {
        return;
      }
      return children;
    },
    handlePosterPreview(file) {
      console.log(file.data.url);
    },
    // 下载模板
    downLoadMb() {
      const loading = this.$loading({
        text: '正在导出...',
        fullscreen: false,
      });
      let rows = [this.tHeader, [], []];
      const sheet = XLSX.utils.aoa_to_sheet(rows);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, sheet, this.title);
      XLSX.writeFile(workbook, this.title + `.xlsx`);
      that.$nextTick(() => {
        loading.close();
      });
    },
    saveData() {
      this.$emit('saveData');
    },
    cancelData() {
      //   this.$emit('cancelData');
      this.$router.push('./questionList');
    },
    beforeUpload(file) {
      this.fileName = file.name;
      const isLt1M = file.size / 1024 / 1024 < 3;
      if (isLt1M) {
        return true;
      }
      this.$message({
        message: '文件过大，不要超过3M',
        type: 'error',
      });
      return false;
    },
    handleImportSuccess({ results, header }) {
      if (results.length === 0) {
        this.$message('表中还没有数据哦，请保存或者重新下载后再试。');
        return;
      }
      console.log('results', results, 'header', header);
      this.getData(results, header);
    },
    getData(arr, header) {
      console.log('arr', arr);
      console.log('header', header);
      let data = arr.map((item, index) => {
        const list = [
          {
            optionName: item[header[1]],
            isCorrect: false,
          },
          {
            optionName: item[header[2]],
            isCorrect: false,
          },
          {
            optionName: item[header[3]],
            isCorrect: false,
          },
          {
            optionName: item[header[4]],
            isCorrect: false,
          },
          {
            optionName: item[header[5]],
            isCorrect: false,
          },
          {
            optionName: item[header[6]],
            isCorrect: false,
          },
          {
            optionName: item[header[7]],
            isCorrect: false,
          },
          {
            optionName: item[header[8]],
            isCorrect: false,
          },
        ];
        list.forEach(() => {
          if (item['正确答案（必填）'] == 'A') {
            list[0].isCorrect = true;
          } else if (item['正确答案（必填）'] == 'B') {
            list[1].isCorrect = true;
          } else if (item['正确答案（必填）'] == 'C') {
            list[2].isCorrect = true;
          } else if (item['正确答案（必填）'] == 'D') {
            list[3].isCorrect = true;
          } else if (item['正确答案（必填）'] == 'E') {
            list[4].isCorrect = true;
          } else if (item['正确答案（必填）'] == 'F') {
            list[5].isCorrect = true;
          } else if (item['正确答案（必填）'] == 'G') {
            list[6].isCorrect = true;
          } else if (item['正确答案（必填）'] == 'H') {
            list[7].isCorrect = true;
          }
        });
        const answer = JSON.stringify(list);
        return {
          categoryId: this.ruleForm.categoryId,
          isSchoolVisible: 1,
          stem: String(item[header[0]]),
          difficulty: item[header[12]] || 2,
          answer,
          analysis: String(item[header[10]]) || '',
          labelName: item[header[11]],
          topicName: item[header[9]],
          topicType: 1,
        };
      });
      const obj = {
        questions: data,
      };
      console.log('导入后的数据', obj);
      that.addSensitive(obj);
    },
    // 添加敏感词
    addSensitive(info) {
      var data = encrypt(JSON.stringify(info));

      batchSaveQuestion(data).then((res) => {
        if (res.result == 1) {
          console.log(res);
          that.$message({
            showClose: true,
            message: '保存成功',
            type: 'success',
          });
          this.$router.push('./questionList');
        } else {
          that.$message({
            showClose: true,
            message: res.msg,
            type: 'error',
          });
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.export-more-files {
  .upload-demo {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 24px auto;
  }
}
</style>
